import { Component, Input, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';

import { AlertService, IAlertType, PersonsStoreService } from '../../../_shared/services';
import { ClrDatagridModule, ClrDatagridSortOrder, ClrModalModule } from '@clr/angular';
import { Personen } from "../../../_shared/interfaces";
import { NgIf } from "@angular/common";

import { environment as env } from "../../../../environments/environment";
@Component({
  selector: 'app-persons-card',
  standalone: true,
  imports: [
    ClrDatagridModule,
    NgIf,
    RouterLink,
    ClrModalModule
  ],
  templateUrl: './persons-card.component.html',
  styleUrl: './persons-card.component.sass'
})

export class PersonsCardComponent implements OnInit {
  activePersons: Personen[] = [];
  inactivePersons: Personen[] = [];
  descSort = ClrDatagridSortOrder.ASC;
  loading: boolean = true;
  public makeACall = false;
  public callTarget: string = '';
  public callFirstname: string= '';
  public callLastname: string= '';
  devMode: boolean;

  @Input() companyId: number = 0;

  constructor(
    private pss: PersonsStoreService,
    public alertDispatcher: AlertService
  ) {
    this.devMode = env.stages.dev;
  }

  ngOnInit() {
    this.loading = true;
    this.loadActiveList(true);
    this.loadPassiveList(false);
  }

  loadActiveList(active: boolean) {
    this.pss.getPersonInCompany(this.companyId, active).subscribe({
      next: data => {
        if (!data || !data.object || data.object.length === 0) {
          this.alertDispatcher.show({
            message: ' Keine Personen gefunden! ',
            clrAlertType: IAlertType.WARNING
          }, 2000);
        }
        this.activePersons = data.object;
      },
      complete: () => {
        this.loading = false;
      },
      error: () => {
        return
      }
    });
  }

  loadPassiveList(active: boolean) {
    this.pss.getPersonInCompany(this.companyId, active).subscribe({
      next: data => {
        if (!data || !data.object || data.object.length === 0) {
          this.alertDispatcher.show({
            message: ' Keine Personen gefunden! ',
            clrAlertType: IAlertType.WARNING
          }, 2000);
        }
        this.inactivePersons = data.object;
      },
      complete: () => {
        this.loading = false;
      },
      error: () => {
        return
      }
    });
  }

  callUrl(phoneNumber: string) {
    const normalizedPhoneNumber = phoneNumber.replace(/[^\d+]/g, '');
    return `tel:${normalizedPhoneNumber}`;
  }

  startCall(phoneNumber: string) {
    window.location.href = this.callUrl(phoneNumber);
  }
}
